import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { QueryString } from '@grandvisionhq/utils';
import ClientSessionManager from '../../../../components/ClientSessionManager/ClientSessionManager.js';
import LayoutContainer from '../../../../components/Layout/LayoutContainer.js';
import useClientSideRouter from '../../../../hooks/use-client-side-router.js';
import { fromArrayToString } from '../../../../utils/from-array-to-string.js';
import '@grandvisionhq/graphql';
import { setStoredAffiliateId } from '../../../../utils/affiliate-id-storage.js';
import { AppointmentContextProvider } from '../AppointmentContext.js';
import { RoutingContext } from './context.js';

const RoutingContextProvider = ({ routeMap , initialRoutingState , initialAppointmentState , children ,  })=>{
    const { Provider  } = RoutingContext;
    const { basePath , currentRoute: initialRoute , queryParams: initialQueryParams ,  } = initialRoutingState;
    const [{ goTo  }, { queryParams: queryParams1 , currentRoute , routerId  }] = useClientSideRouter({
        basePath,
        initialRoute,
        initialQueryParams,
        routerId: 'book-appointment'
    });
    const { href: signInMyAccountUrl  } = useLink({
        route: 'auth.login'
    }) || {};
    const goToHandler = React.useCallback((route, queryParams)=>{
        const newQueryParams = swcHelpers.objectSpread({}, queryParams, {
            tryInStoreFlow: initialQueryParams.tryInStoreFlow ? '1' : undefined
        });
        Object.keys(newQueryParams).forEach((key)=>newQueryParams[key] === undefined ? delete newQueryParams[key] : {}
        );
        goTo(`${basePath}/${route}${QueryString.stringify(newQueryParams)}`);
    }, [
        basePath,
        goTo,
        initialQueryParams.tryInStoreFlow
    ]);
    const value = React.useMemo(()=>[
            {
                goTo: goToHandler
            },
            {
                component: routeMap[currentRoute],
                queryParams: queryParams1,
                currentRoute,
                basePath,
                signInMyAccountUrl,
                routerId
            }, 
        ]
    , [
        routeMap,
        goToHandler,
        currentRoute,
        basePath,
        queryParams1,
        signInMyAccountUrl,
        routerId
    ]);
    const RootComponent = routeMap[currentRoute];
    React.useEffect(()=>{
        if (initialQueryParams === null || initialQueryParams === void 0 ? void 0 : initialQueryParams.affiliateId) {
            setStoredAffiliateId(fromArrayToString(initialQueryParams === null || initialQueryParams === void 0 ? void 0 : initialQueryParams.affiliateId));
        }
    }, [
        initialQueryParams
    ]);
    return /*#__PURE__*/ React.createElement(Provider, {
        value: value
    }, /*#__PURE__*/ React.createElement(AppointmentContextProvider, {
        initialState: initialAppointmentState
    }, /*#__PURE__*/ React.createElement(LayoutContainer, null, /*#__PURE__*/ React.createElement(ClientSessionManager, {
        initialRoute: initialRoute
    }, /*#__PURE__*/ React.createElement(RootComponent, null), children))));
};
RoutingContextProvider.getServerSideProps = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, currentRoute, routeMap, params, locale) {
        const isValidRoute = currentRoute in routeMap;
        if (!isValidRoute) {
            throw new Error('UNKNOWN_ERROR');
        }
        const RootComponent = routeMap[currentRoute];
        const initialAppointmentState = yield RootComponent.getServerSideProps(apolloClient, params, locale);
        return {
            initialAppointmentState
        };
    });
    return function(apolloClient, currentRoute, routeMap, params, locale) {
        return _ref.apply(this, arguments);
    };
}();

export { RoutingContextProvider };
//# sourceMappingURL=provider.js.map
